import AOS from "aos";
import 'aos/dist/aos.css';
import React, { Component } from "react";
import './App.css';
import TabViewModal from "./common/drawer";
import About from "./component/about";
import Intro from "./component/intro";
import Menu from "./component/menu";
import { BsInstagram } from "react-icons/bs";
import { AiFillGithub } from "react-icons/ai";
import { RiLinkedinLine } from "react-icons/ri";
import Experties from "./component/experties";
class App extends Component {
    state = {
        toggle: false,
        direction: "",
        scrollCounter: 0,
        children: "",
        locked: false,
        windowsWidth: window.innerWidth
    }

    componentDidMount() {
        AOS.init();
        window.addEventListener('resize', this.windowResize.bind(this));
    }

    windowResize() {
        this.setState({ windowsWidth: window.innerWidth });
    }

    setMenuToggle = () => {
        const { toggle } = this.state;
        this.setState({ toggle: !toggle })
    }
    renderMenu() {
        const { windowsWidth, toggle } = this.state;
        return (
            <>
                {
                    windowsWidth > 900
                        ? <Menu showMenu={toggle} />
                        : <div className="tab-view">
                            <TabViewModal showMenu={toggle} showMenuToggle={this.setMenuToggle} />
                        </div>
                }
            </>
        )
    }

    render() {
        const { toggle, direction } = this.state;
        return (
            <React.Fragment>
                <section className={`main-container ${direction}`} style={{ minHeight: '110vh', background: '#131419' }}>
                    <section className="d-flex">
                        <div orientation="left" className="connect">
                            <ul className="list-group">
                                <li className="list-group-item bg-transparent mb-2"><a href="https://www.instagram.com/aman_pahariya_g_/" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><BsInstagram size={22} /></a></li>
                                <li className="list-group-item bg-transparent mb-2"><a href="https://github.com/amanpahariya" aria-label="Github" target="_blank" rel="noopener noreferrer"><AiFillGithub size={22} /></a></li>
                                <li className="list-group-item bg-transparent mb-4"><a href="https://www.linkedin.com/in/amanguptag/" aria-label="Linkedin" target="_blank" rel="noopener noreferrer"><RiLinkedinLine size={22} /></a></li>
                            </ul>
                        </div>
                        <div className="content w-100">
                            <Intro
                                showMenu={toggle}
                                setDirection={(value) => this.setState({ direction: value })}
                                showMenuToggle={(value) => this.setState({ toggle: value })}
                            />
                            <About />
                            <Experties />
                            {/* <Skills /> */}
                        </div>
                        <div orientation="right" className="email">
                            <a href="mailto:amangupta201497@gmail.com" className="mb-4">amangupta201497@gmail.com</a>
                        </div>
                    </section>
                </section>
                {this.renderMenu()}
            </React.Fragment>
        )
    }
}

export default App;